import { ProgramKpis } from '../components/ProgramKpis';
import { ProgramsTable } from '../components/ProgramsTable';

export const Programs = () => {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-xl font-semibold text-gray-900">Programs</h1>
      <ProgramKpis />
      <ProgramsTable />
    </div>
  );
};
